// import { ITEM_ASSETS_API, MANAGE_ITEM_API } from '../../../../Utilities/APIs/APIs'
// import PcIPSCRUD from '../../../Partials/Layouts/CRUDs/CRUDLayouts/IPSCRUD/PcIPSCRUD'

import { useContext, useEffect, useState } from "react"
import AppContext from "../../../../AppContext/AppContext"
import useAxiosInstance from "../../../../Utilities/Hooks/useAxiosInstance"
import { IMAGE_URL, ITEM_ASSETS_API } from "../../../../Utilities/APIs/APIs"
import CreateButton from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDDashboardBoilerplate/CRUDHeader/CreateButton/CreateButton"
import CRUDTable from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTable"
import CRUDTableHeader from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDTableHeader"
import CRUDth from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDth/CRUDth"
import CRUDTableRow from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableRow/CRUDTableRow"
import ShortTextCell from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell"
import ViewButton from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/ViewButton/ViewButton"
import EditButton from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/EditButton/EditButton"
import DeleteButton from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/DeleteButton/DeleteButton"
import Modal from "../../../Partials/Elements/Modal/Modal"
import ImageCell from "../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableCells/ImageCell/ImageCell"
import CreateItemAssets from "./CreateItemAssets"
import ViewItemAssets from "./ViewItemAssets"
import { useParams } from "react-router-dom"
import UpdateItemAssets from "./UpdateItemAssets"
import DeleteItem from "../../../Partials/Layouts/DeleteItem/DeleteItem"

// function ItemAssetsFromItems() {
//     return (
//         <PcIPSCRUD

//             // parentChild props
//             parentDBField='item'

//             // common props
//             api={ITEM_ASSETS_API}
//             screenTopicSingular={'Item Asset'}
//             screenTopicPlural={'Item Assets'}
            
//             // crud header props
//             showTotalInHeading
            
//             // crud props
//             allowCreate
//             allowUpdate
//             allowDelete
            
//             // field props
//             maxPrecedence={4}
            
//             // select props
//             selectApi={MANAGE_ITEM_API}
//             selectType={'parent-child'}
//             selectDBField={'item'}
//             selectName={'Item'}
//         />
//     )
// }

// export default ItemAssetsFromItems





function ItemAssetsFromItems() {

    const [itemAssets, setItemAssets] = useState(null)
    const [showModal, setShowModal] = useState(false)
    const [targetID, setTargetID] = useState(null)
    const [showViewSection, setShowViewSection] = useState(false)
    const [showCreateForm, setShowCreateForm] = useState(false)
    const [showUpdateForm, setShowUpdateForm] = useState(false)
    const [showDeleteSection, setShowDeleteSection] = useState(false)
    const [toggleFetch, setToggleFetch] = useState(false)
    const { employee } = useContext(AppContext)

    const {itemID} =useParams()
   
    const axiosInstance = useAxiosInstance()

    useEffect(() => {

        async function fetchAndSetItemAssets() {
            const { data } = await axiosInstance.get(ITEM_ASSETS_API)
            setItemAssets(data)
        }
        fetchAndSetItemAssets()


    }, [toggleFetch, axiosInstance])

    function handleClose() {
        setShowModal(false);
        setShowCreateForm(false);
        setShowViewSection(false);
        setShowUpdateForm(false);
        setShowDeleteSection(false);
    }

    function triggerFetch() {
        setToggleFetch(prevState => !prevState)
    }


    return (
        <>
            <div className='crud_holder'>
                <div className="body_header">
                    <h1 className="heading">{`Item Assets (${itemAssets?.length} in total)`}</h1>
                    <CreateButton
                        screenTopicSingular='Item Assets'
                        setShowModal={setShowModal}
                        setShowCreateForm={setShowCreateForm}
                    />
                </div>
                <CRUDTable>
                    <CRUDTableHeader>
                        <CRUDth th='Image' />
                        <CRUDth th='Precedence'/>
                    </CRUDTableHeader>
                    <tbody>
                        {itemAssets?.map(itemAsset => (
                            <CRUDTableRow key={itemAsset?._id}>
                                <ImageCell imgSrc={IMAGE_URL + itemAsset?.image} alt={itemAsset?.name} />
                                <ShortTextCell text={itemAsset?.precedence} />


                                <td className="action_button_cell">
                                    {/* <ViewButton
                                        setShowModal={setShowModal}
                                        setShowViewSection={setShowViewSection}
                                        targetID={itemAsset._id}
                                        setTargetID={setTargetID}
                                    /> */}
                                    <EditButton
                                        setShowModal={setShowModal}
                                        setShowUpdateForm={setShowUpdateForm}
                                        targetID={itemAsset._id}
                                        setTargetID={setTargetID}
                                    />
                                    <DeleteButton
                                        setShowModal={setShowModal}
                                        setShowDeleteSection={setShowDeleteSection}
                                        targetID={itemAsset._id}
                                        setTargetID={setTargetID}
                                    />

                                </td>
                            </CRUDTableRow>
                        ))}
                    </tbody>
                </CRUDTable>
            </div>
            {showModal &&
                <Modal
                    view
                    handleClose={handleClose}
                    modalHeading={
                        (showCreateForm && `Create Item Assets`) ||
                        (showUpdateForm && `Update Item Assets`) ||
                        (showDeleteSection && `Delete Item Assets`)
                    }
                >
                    {
                        showCreateForm &&
                        <CreateItemAssets
                            employee={employee}
                            setShowCreateForm={setShowCreateForm}
                            setShowModal={setShowModal}
                            triggerFetch={triggerFetch}
                            itemID={itemID}
                        />
                    }
                    {
                        showUpdateForm &&
                        <UpdateItemAssets
                            employee={employee}
                            targetID={targetID}
                            setShowUpdateForm={setShowUpdateForm}
                            setShowModal={setShowModal}
                            triggerFetch={triggerFetch}
                        />
                    }

                    {
                        showDeleteSection &&
                        <DeleteItem
                            api={ITEM_ASSETS_API}
                            targetID={targetID}
                            employee={employee}
                            setShowModal={setShowModal}
                            setShowDeleteSection={setShowDeleteSection}
                            hasName
                            triggerFetch={triggerFetch}
                        />
                    }
                </Modal>
            }

            {/* {showModal && showViewSection &&
                <Modal
                    view
                    handleClose={handleClose}
                    modalHeading={
                        (showViewSection && `View Item Assets`)
                    }
                >
                    <ViewItemAssets
                        targetID={targetID}
                        employee={employee}
                    />
                </Modal>
            } */}
        </>
    )
}

export default ItemAssetsFromItems